import React, {useEffect, useState} from 'react';

export const useRerenderInterval = (timeout = 1000) => {
    const [counter, setCounter] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setCounter(counter + 1)
        }, timeout)

        return () => {
            clearInterval(interval);
        }
    }, [timeout, counter, setCounter]);
}
